export const AXES = [
  { label: "X", index: 0 },
  { label: "Y", index: 1 },
  { label: "Z", index: 2 },
] as const;

// TODO: These conversions should be removed from the frontend
export const FIELD_TO_PAYLOAD_KEY = {
  position: "translation",
  processedPosition: "opticalCenter",
} as const;
